import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import DatePicker from "react-datepicker";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import { addDays, addMonths } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";

import { ANY_ERROR } from "../../../action/user_action_types";
import http from "../../../util/http";

class ExcelRecPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: null,
      endDate: null,
      campaignData: [],
    };
  }

  handleStartDate = (startDate) => {
    let { endDate } = this.state;
    if (endDate && endDate < startDate) {
      return this.props.showError("End date an not less then start Date!");
    }
    this.setState({ startDate });
  };

  handleLastDate = (endDate) => {
    let { startDate } = this.state;
    if (startDate && startDate > endDate) {
      return this.props.showError(
        "Start date can not be grater then End date!"
      );
    }
    this.setState({ endDate });
  };

  generateExcel = async (event) => {
    event.preventDefault();
    let { startDate, endDate } = this.state;
    if (!startDate || !endDate) {
      return this.props.showError("Start date and End date is required!");
    }
    console.log(new Date(startDate));
    let fromDate = new Date();
    var f = new Date(startDate);
    var e = new Date(endDate);
    f.setHours(0);
    console.log(f);
    e.setHours(23);
    console.log(e);
    let query = `startDate=${f.getTime()}&endDate=${e.getTime()}`;
    let url = `/admin/generate-recon-excel?${query}`;
    let response = await http.get(url);
    if (response && response.data.statusCode == 200) {
      this.formatXls(response.data.data);
      this.props.hideExcelPopup();
    } else {
      this.props.showError(response.data.message);
      this.props.hideExcelPopup();
    }
  };

  formatXls = (data) => {
    let campaignData = [];
    data.map((c, index) => {
      let obj = Object.assign({}, c, {
        s_no: index + 1,
        paymentdate: moment(parseInt(c.paymentDate) * 1000).format(
          "DD/MM/YYYY"
        ),
        paymentstatus: c.status,
        settlementdate:
          c.settlementDetails &&
          c.settlementDetails.settled_at &&
          c.settlementDetails.settled_at &&
          moment(c.settlementDetails.settled_at * 1000).format("DD/MM/YYYY"),
        settlementid: c.settlementDetails && c.settlementDetails.settlement_id,
        settlementamount:
          c.settlementDetails && c.settlementDetails.amountReceived,
        razorpayfee: c.settlementDetails && c.settlementDetails.razorPayfee,
        gstfee: c.settlementDetails && c.settlementDetails.razorpayTax,
        totalfee: c.settlementDetails && c.settlementDetails.totalfee,
        utrno: c.settlementDetails && c.settlementDetails.settlement_utr,
        email: c.customerDetails && c.customerDetails.email,
        number: c.customerDetails && c.customerDetails.contact,
        name: c.customerDetails && c.customerDetails.name,
        company: c.customerDetails && c.customerDetails.company,
        gstno: c.customerDetails && c.customerDetails.gstno,
      });
      campaignData.push(obj);
      console.log(campaignData);
    });
    this.setState({ campaignData }, () => {
      this._exporter.save();
    });
  };

  render() {
    let { startDate, endDate, campaignData } = this.state;
    return (
      <div>
        <div className="modal-overlay">
          <div
            className="modal-wrapper thankyou-popup"
            aria-modal
            aria-hidden
            tabIndex={-1}
            role="dialog"
          >
            <div className="modal">
              <div className="modal-head-cross rate-modal">
                <button
                  type="button"
                  className="modal-close-button"
                  onClick={() => this.props.hideExcelPopup()}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="editNonFct-header modal-header">
                  <h4 className="popup-head rqst-head fct-head modal-title">
                    Select Date Range
                  </h4>
                </div>
                <div className="editNonFct-modal modal-body">
                  <div className="bg-white">
                    <form className="form-group">
                      <div className="popupCampaign-container">
                        <div className="campaign-input master-inputs nonFct">
                          <div className="input-tag signup-tag clearfix fct-input">
                            <label className="static-value date_label">
                              Start Date
                            </label>
                            <DatePicker
                              selected={startDate}
                              onChange={this.handleStartDate}
                              maxDate={endDate}
                              minDate={addDays(new Date(), -500)}
                            />
                          </div>
                        </div>
                        <div className="campaign-input master-inputs nonFct">
                          <div className="input-tag signup-tag clearfix fct-input">
                            <label className="static-value date_label">
                              End Date
                            </label>
                            <DatePicker
                              selected={endDate}
                              onChange={this.handleLastDate}
                              minDate={startDate}
                              maxDate={addDays(new Date(), 0)}
                            />
                          </div>
                        </div>
                        <div className="create-camp nonfct-submit">
                          <button onClick={this.generateExcel}>DOWNLOAD</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ExcelExport
          data={campaignData}
          fileName="Reconciliation.xlsx"
          ref={(exporter) => {
            this._exporter = exporter;
          }}
        >
          <ExcelExportColumn field="paymentId" title="Payment ID" />
          <ExcelExportColumn field="campaignName" title="Campaign Name" />
          <ExcelExportColumn field="paymentdate" title="Payment Date" />
          <ExcelExportColumn field="paymentstatus" title="Payment Status" />
          <ExcelExportColumn field="amount" title="Transaction Amount" />
          <ExcelExportColumn field="settlementdate" title="Settlement date" />
          <ExcelExportColumn field="settlementid" title="Settlement ID" />
          <ExcelExportColumn
            field="settlementamount"
            title="Settlement Amount"
          />
          <ExcelExportColumn field="razorpayfee" title="Razorpay Fee" />
          <ExcelExportColumn field="gstfee" title="Gst on RP Fee" />
          <ExcelExportColumn field="totalfee" title="Total Fee" />
          <ExcelExportColumn field="utrno" title="UTR No" />
          <ExcelExportColumn field="email" title="Customer Email" />
          <ExcelExportColumn field="number" title="Customer Number" />
          <ExcelExportColumn field="name" title="Customer Name" />
          <ExcelExportColumn field="company" title="Company Name" />
          <ExcelExportColumn field="gstno" title="GST No" />
        </ExcelExport>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showError: (error) =>
      dispatch({
        type: ANY_ERROR,
        payload: error,
      }),
  };
};

export default connect(null, mapDispatchToProps)(ExcelRecPopup);



// WEBPACK FOOTER //
// ./web/components/admin/manageCampaign/ExportRecon.jsx